import { useEffect, useState } from 'react';

/**
 * Returns true when the current URL carries `?sessionExpired=<value>`. Used to
 * surface different post-logout hints depending on what triggered the expiry:
 * `autoLogout` (idle timeout) shows an inline alert on the login page,
 * `csrf` (stale CSRF token) shows a toast from the auth layout.
 */
export function useSessionExpiredFlag(value: string): boolean {
    const [matched, setMatched] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setMatched(params.get('sessionExpired') === value);
    }, [value]);

    return matched;
}
